import { createNode, PlainTimeDataType } from '@glueapp/graph-types';
import { Temporal } from '@js-temporal/polyfill';
import { fromPlainTime } from '../../utils/temporal';

export const NowTime = createNode({
    id: 'Now (Time)',
    name: 'Now (Time)',
    description: 'Returns the current time, optionally in a specific timezone',
    aiDescription:
        'Takes an optional timezone string on the "Timezone" port and outputs the current Time on the "Time" port. Defaults to the system timezone.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Timezone: { kind: 'string' },
    },
    optionalInPorts: ['Timezone'],
    outPorts: {
        Time: PlainTimeDataType,
    },
    execute: function (input) {
        const timezone = input.inPorts.Timezone ?? Temporal.Now.timeZoneId();
        const time = Temporal.Now.plainTimeISO(timezone);
        return { output: { Time: fromPlainTime(time) } };
    },
});
